var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }]
  }, [_c('div', {
    staticClass: "popup_wrap customModal"
  }, [_c('div', {
    staticClass: "popup_title"
  }, [_vm._m(0), _c('a', {
    staticClass: "_command[CmmComm.closeLayer]"
  }, [_c('div', {
    staticClass: "btn_close",
    attrs: {
      "id": "popup_close",
      "title": "Close"
    },
    on: {
      "click": _vm.popupClose
    }
  }, [_vm._m(1)])])]), _vm._m(2), _vm._m(3)]), _c('div', {
    staticClass: "mask_wrap",
    staticStyle: {
      "display": "block"
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('span', {
    attrs: {
      "id": "node_title"
    }
  }, [_vm._v("Popup Title test")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup_content1"
  }, [_c('div', {
    staticClass: "node_order_wrap"
  }, [_c('div', {
    staticClass: "node_order_box_left"
  }, [_c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v("순서")]), _c('div', {
    staticClass: "node_name_box"
  }, [_c('div', {
    staticClass: "box_stitle2 node_title W100"
  }, [_c('input', {
    staticClass: "W100 validate[required]",
    attrs: {
      "type": "text",
      "name": "node_title"
    }
  })])]), _c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v("속성")]), _c('table', {
    staticClass: "board_node",
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _c('col', {
    attrs: {
      "width": "*"
    }
  })]), _c('tbody', [_c('tr', [_c('th', [_vm._v("속성명")]), _c('td', [_c('input', {
    staticClass: "W100 validate[required]",
    attrs: {
      "type": "text",
      "name": "nodeSubTitle"
    }
  })])]), _c('tr', [_c('th', [_vm._v("속성타입")]), _c('td', [_c('input', {
    staticClass: "validate[required]",
    attrs: {
      "type": "radio",
      "name": "attrType",
      "value": "inputText",
      "id": "inputText"
    }
  }), _c('label', {
    attrs: {
      "for": "inputText"
    }
  }, [_vm._v(" String ")]), _c('br'), _c('input', {
    staticClass: "validate[required]",
    attrs: {
      "type": "radio",
      "name": "attrType",
      "value": "longText",
      "id": "longText"
    }
  }), _c('label', {
    attrs: {
      "for": "longText"
    }
  }, [_vm._v(" Number ")]), _c('br')])]), _c('tr', [_c('th', [_vm._v("속성단위")]), _c('td', [_c('input', {
    staticClass: "W100",
    attrs: {
      "type": "text",
      "value": "℃"
    }
  })])]), _c('tr', {
    staticClass: "optionTr",
    staticStyle: {
      "display": "none"
    }
  }, [_c('th', [_c('div', {
    staticClass: "mb5"
  }, [_vm._v("속성옵션")]), _c('a', {
    staticClass: "btn_type1_sm _command[CmmAddAttribute.addOption]"
  }, [_vm._v("+")])]), _c('td', [_c('div', {
    staticClass: "optionDiv"
  }, [_c('input', {
    staticClass: "validate[required]",
    attrs: {
      "type": "text",
      "name": "option"
    }
  }), _c('a', {
    staticClass: "btn_node_delete_b _command[CmmAddAttribute.delOption]"
  }, [_vm._v(" ")]), _c('a', {
    staticClass: "btn_node_change_b"
  }, [_vm._v(" ")])]), _c('div', {
    staticClass: "optionDiv"
  }, [_c('input', {
    staticClass: "validate[required]",
    attrs: {
      "type": "text",
      "name": "option"
    }
  }), _c('a', {
    staticClass: "btn_node_delete_b _command[CmmAddAttribute.delOption]"
  }, [_vm._v(" ")]), _c('a', {
    staticClass: "btn_node_change_b"
  }, [_vm._v(" ")])]), _c('div', {
    staticClass: "optionDiv"
  }, [_c('input', {
    staticClass: "validate[required]",
    attrs: {
      "type": "text",
      "name": "option"
    }
  }), _c('a', {
    staticClass: "btn_node_delete_b _command[CmmAddAttribute.delOption]"
  }, [_vm._v(" ")]), _c('a', {
    staticClass: "btn_node_change_b"
  }, [_vm._v(" ")])])])])])]), _c('div', {
    staticClass: "text_right mt10"
  }, [_c('a', {
    staticClass: "btn_type1_sm _command[CmmAddAttribute.addAttribute]"
  }, [_vm._v("속성추가 →")])])]), _c('div', {
    staticClass: "node_order_box_right"
  }, [_c('div', {
    staticClass: "site_memo_nothing"
  }, [_c('div', {
    attrs: {
      "clas": "node_nothing_icon"
    }
  }), _c('div', {
    staticClass: "node_nothing_text"
  }, [_c('span', [_vm._v("왼쪽 편집창에서")]), _vm._v(" 노드속성을 추가해 주세요. ")])]), _c('div', {
    staticClass: "node_result_box",
    attrs: {
      "id": "a02c425e-48db-492f-8314-b5e461a37a15"
    }
  }, [_c('h4', {
    staticClass: "site_detail_tit"
  }, [_vm._v("LongText "), _c('div', {
    staticClass: "node_result_box_btn"
  }, [_c('a', {
    staticClass: "btn_node_delete"
  }, [_vm._v(" ")]), _c('a', {
    staticClass: "btn_node_change"
  }, [_vm._v(" ")])])]), _c('div', {
    staticClass: "site_detail_con"
  }, [_c('textarea', {
    attrs: {
      "name": "a02c425e-48db-492f-8314-b5e461a37a15"
    }
  })])]), _c('div', {
    staticClass: "node_result_box",
    attrs: {
      "id": "f4d264ca-1f47-4a19-a300-af542d754f4c"
    }
  }, [_c('h4', {
    staticClass: "site_detail_tit"
  }, [_vm._v("Radio "), _c('div', {
    staticClass: "node_result_box_btn"
  }, [_c('a', {
    staticClass: "btn_node_delete"
  }, [_vm._v(" ")]), _c('a', {
    staticClass: "btn_node_change"
  }, [_vm._v(" ")])])]), _c('div', {
    staticClass: "site_detail_con"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "f4d264ca-1f47-4a19-a300-af542d754f4c",
      "id": "845bb3f8-43aa-4781-8686-66af0baec5cd",
      "value": "Radio1"
    }
  }), _c('label', {
    attrs: {
      "for": "845bb3f8-43aa-4781-8686-66af0baec5cd"
    }
  }, [_vm._v("Radio1")]), _c('br'), _c('input', {
    attrs: {
      "type": "radio",
      "name": "f4d264ca-1f47-4a19-a300-af542d754f4c",
      "id": "8c480c10-a646-4c7c-9d2c-d8557e25992e",
      "value": "Radio2"
    }
  }), _c('label', {
    attrs: {
      "for": "8c480c10-a646-4c7c-9d2c-d8557e25992e"
    }
  }, [_vm._v("Radio2")]), _c('br'), _c('input', {
    attrs: {
      "type": "radio",
      "name": "f4d264ca-1f47-4a19-a300-af542d754f4c",
      "id": "8781fa3c-060f-4fb1-8402-8ecaea3bc488",
      "value": "Radio3"
    }
  }), _c('label', {
    attrs: {
      "for": "8781fa3c-060f-4fb1-8402-8ecaea3bc488"
    }
  }, [_vm._v("Radio3")]), _c('br')])]), _c('div', {
    staticClass: "node_result_box",
    attrs: {
      "id": "98a08c4a-e261-44ac-81c7-895c37c3ead4"
    }
  }, [_c('h4', {
    staticClass: "site_detail_tit"
  }, [_vm._v("Check "), _c('div', {
    staticClass: "node_result_box_btn"
  }, [_c('a', {
    staticClass: "btn_node_delete"
  }, [_vm._v(" ")]), _c('a', {
    staticClass: "btn_node_change"
  }, [_vm._v(" ")])])]), _c('div', {
    staticClass: "site_detail_con"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "98a08c4a-e261-44ac-81c7-895c37c3ead4",
      "id": "d0be9bb1-1985-427c-b6fe-5e34f5b82d40",
      "value": "Check1"
    }
  }), _c('label', {
    attrs: {
      "for": "d0be9bb1-1985-427c-b6fe-5e34f5b82d40"
    }
  }, [_vm._v("Check1")]), _c('br'), _c('input', {
    attrs: {
      "type": "checkbox",
      "name": "98a08c4a-e261-44ac-81c7-895c37c3ead4",
      "id": "c71e97a5-bf16-4b22-82f6-b0bad3c60c4a",
      "value": "Check2"
    }
  }), _c('label', {
    attrs: {
      "for": "c71e97a5-bf16-4b22-82f6-b0bad3c60c4a"
    }
  }, [_vm._v("Check2")]), _c('br'), _c('input', {
    attrs: {
      "type": "checkbox",
      "name": "98a08c4a-e261-44ac-81c7-895c37c3ead4",
      "id": "f67a585c-f5e9-4bb1-99f7-87952d3a782b",
      "value": "Check3"
    }
  }), _c('label', {
    attrs: {
      "for": "f67a585c-f5e9-4bb1-99f7-87952d3a782b"
    }
  }, [_vm._v("Check3")]), _c('br')])]), _c('div', {
    staticClass: "node_result_box",
    attrs: {
      "id": "dc65b6cb-e125-4c20-9567-fdc12906fbe4"
    }
  }, [_c('h4', {
    staticClass: "site_detail_tit"
  }, [_vm._v("첨부파일 "), _c('div', {
    staticClass: "node_result_box_btn"
  }, [_c('a', {
    staticClass: "btn_node_delete"
  }, [_vm._v(" ")]), _c('a', {
    staticClass: "btn_node_change"
  }, [_vm._v(" ")])])]), _c('div', {
    staticClass: "site_detail_con"
  }, [_c('div', [_c('input', {
    attrs: {
      "type": "text"
    }
  }), _c('button', {
    staticClass: "coll_btn coll_btn_open"
  })]), _c('ul', {
    staticClass: "attach_file_list mt5"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("첨부파일.pdf")])]), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("AttachFile.pdf")])]), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("첨부파일.pdf")])])])])]), _c('div', {
    staticClass: "node_result_box",
    attrs: {
      "id": "800ff8e7-f000-47f8-ab2b-5460d03e987c"
    }
  }, [_c('h4', {
    staticClass: "site_detail_tit"
  }, [_vm._v("에디터 "), _c('div', {
    staticClass: "node_result_box_btn"
  }, [_c('a', {
    staticClass: "btn_node_delete"
  }, [_vm._v(" ")]), _c('a', {
    staticClass: "btn_node_change"
  }, [_vm._v(" ")])])]), _c('div', {
    staticClass: "site_detail_con"
  }, [_vm._v(" 에디터 팝업 띄우기 버튼. ")])])])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup_footer"
  }, [_c('a', {
    staticClass: "btn_type1 _command[CmmAddAttribute.saveProc]"
  }, [_vm._v("저장")]), _c('a', {
    staticClass: "btn_type3 _command[CmmComm.closeLayer]"
  }, [_vm._v("닫기")])]);

}]

export { render, staticRenderFns }